export const eulerVaultConnectorAbi = [
  { inputs: [], stateMutability: 'nonpayable', type: 'constructor' },
  { inputs: [], name: 'EVC_BatchPanic', type: 'error' },
  { inputs: [], name: 'EVC_ChecksReentrancy', type: 'error' },
  { inputs: [], name: 'EVC_ControlCollateralReentrancy', type: 'error' },
  { inputs: [], name: 'EVC_ControllerViolation', type: 'error' },
  { inputs: [], name: 'EVC_EmptyError', type: 'error' },
  { inputs: [], name: 'EVC_InvalidAddress', type: 'error' },
  { inputs: [], name: 'EVC_InvalidData', type: 'error' },
  { inputs: [], name: 'EVC_InvalidNonce', type: 'error' },
  { inputs: [], name: 'EVC_InvalidOperatorStatus', type: 'error' },
  { inputs: [], name: 'EVC_InvalidTimestamp', type: 'error' },
  { inputs: [], name: 'EVC_InvalidValue', type: 'error' },
  { inputs: [], name: 'EVC_LockdownMode', type: 'error' },
  { inputs: [], name: 'EVC_NotAuthorized', type: 'error' },
  { inputs: [], name: 'EVC_OnBehalfOfAccountNotAuthenticated', type: 'error' },
  { inputs: [], name: 'EVC_PermitDisabledMode', type: 'error' },
  {
    inputs: [
      {
        components: [
          { internalType: 'bool', name: 'success', type: 'bool' },
          { internalType: 'bytes', name: 'result', type: 'bytes' },
        ],
        internalType: 'struct IEVC.BatchItemResult[]',
        name: 'batchItemsResult',
        type: 'tuple[]',
      },
      {
        components: [
          { internalType: 'address', name: 'checkedAddress', type: 'address' },
          { internalType: 'bool', name: 'isValid', type: 'bool' },
          { internalType: 'bytes', name: 'result', type: 'bytes' },
        ],
        internalType: 'struct IEVC.StatusCheckResult[]',
        name: 'accountsStatusResult',
        type: 'tuple[]',
      },
      {
        components: [
          { internalType: 'address', name: 'checkedAddress', type: 'address' },
          { internalType: 'bool', name: 'isValid', type: 'bool' },
          { internalType: 'bytes', name: 'result', type: 'bytes' },
        ],
        internalType: 'struct IEVC.StatusCheckResult[]',
        name: 'vaultsStatusResult',
        type: 'tuple[]',
      },
    ],
    name: 'EVC_RevertedBatchResult',
    type: 'error',
  },
  { inputs: [], name: 'EVC_SimulationBatchNested', type: 'error' },
  { inputs: [], name: 'InvalidIndex', type: 'error' },
  { inputs: [], name: 'TooManyElements', type: 'error' },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: true, internalType: 'address', name: 'controller', type: 'address' },
    ],
    name: 'AccountStatusCheck',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'caller', type: 'address' },
      { indexed: true, internalType: 'bytes19', name: 'onBehalfOfAddressPrefix', type: 'bytes19' },
      { indexed: false, internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
      { indexed: true, internalType: 'address', name: 'targetContract', type: 'address' },
      { indexed: false, internalType: 'bytes4', name: 'selector', type: 'bytes4' },
    ],
    name: 'CallWithContext',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: true, internalType: 'address', name: 'collateral', type: 'address' },
      { indexed: false, internalType: 'bool', name: 'enabled', type: 'bool' },
    ],
    name: 'CollateralStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'address', name: 'account', type: 'address' },
      { indexed: true, internalType: 'address', name: 'controller', type: 'address' },
      { indexed: false, internalType: 'bool', name: 'enabled', type: 'bool' },
    ],
    name: 'ControllerStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { indexed: false, internalType: 'bool', name: 'enabled', type: 'bool' },
    ],
    name: 'LockdownModeStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { indexed: true, internalType: 'uint256', name: 'nonceNamespace', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'oldNonce', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'newNonce', type: 'uint256' },
    ],
    name: 'NonceStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { indexed: true, internalType: 'uint256', name: 'nonceNamespace', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'nonce', type: 'uint256' },
    ],
    name: 'NonceUsed',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'accountOperatorAuthorized', type: 'uint256' },
    ],
    name: 'OperatorStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
    ],
    name: 'OwnerRegistered',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { indexed: false, internalType: 'bool', name: 'enabled', type: 'bool' },
    ],
    name: 'PermitDisabledModeStatus',
    type: 'event',
  },
  {
    anonymous: false,
    inputs: [{ indexed: true, internalType: 'address', name: 'vault', type: 'address' }],
    name: 'VaultStatusCheck',
    type: 'event',
  },
  {
    inputs: [],
    name: 'areChecksDeferred',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'areChecksInProgress',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: 'targetContract', type: 'address' },
          { internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
          { internalType: 'uint256', name: 'value', type: 'uint256' },
          { internalType: 'bytes', name: 'data', type: 'bytes' },
        ],
        internalType: 'struct IEVC.BatchItem[]',
        name: 'items',
        type: 'tuple[]',
      },
    ],
    name: 'batch',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: 'targetContract', type: 'address' },
          { internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
          { internalType: 'uint256', name: 'value', type: 'uint256' },
          { internalType: 'bytes', name: 'data', type: 'bytes' },
        ],
        internalType: 'struct IEVC.BatchItem[]',
        name: 'items',
        type: 'tuple[]',
      },
    ],
    name: 'batchRevert',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      {
        components: [
          { internalType: 'address', name: 'targetContract', type: 'address' },
          { internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
          { internalType: 'uint256', name: 'value', type: 'uint256' },
          { internalType: 'bytes', name: 'data', type: 'bytes' },
        ],
        internalType: 'struct IEVC.BatchItem[]',
        name: 'items',
        type: 'tuple[]',
      },
    ],
    name: 'batchSimulation',
    outputs: [
      {
        components: [
          { internalType: 'bool', name: 'success', type: 'bool' },
          { internalType: 'bytes', name: 'result', type: 'bytes' },
        ],
        internalType: 'struct IEVC.BatchItemResult[]',
        name: 'batchItemsResult',
        type: 'tuple[]',
      },
      {
        components: [
          { internalType: 'address', name: 'checkedAddress', type: 'address' },
          { internalType: 'bool', name: 'isValid', type: 'bool' },
          { internalType: 'bytes', name: 'result', type: 'bytes' },
        ],
        internalType: 'struct IEVC.StatusCheckResult[]',
        name: 'accountsStatusCheckResult',
        type: 'tuple[]',
      },
      {
        components: [
          { internalType: 'address', name: 'checkedAddress', type: 'address' },
          { internalType: 'bool', name: 'isValid', type: 'bool' },
          { internalType: 'bytes', name: 'result', type: 'bytes' },
        ],
        internalType: 'struct IEVC.StatusCheckResult[]',
        name: 'vaultsStatusCheckResult',
        type: 'tuple[]',
      },
    ],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'targetContract', type: 'address' },
      { internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
      { internalType: 'uint256', name: 'value', type: 'uint256' },
      { internalType: 'bytes', name: 'data', type: 'bytes' },
    ],
    name: 'call',
    outputs: [{ internalType: 'bytes', name: 'result', type: 'bytes' }],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'targetCollateral', type: 'address' },
      { internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
      { internalType: 'uint256', name: 'value', type: 'uint256' },
      { internalType: 'bytes', name: 'data', type: 'bytes' },
    ],
    name: 'controlCollateral',
    outputs: [{ internalType: 'bytes', name: 'result', type: 'bytes' }],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
    ],
    name: 'disableCollateral',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'disableController',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
    ],
    name: 'enableCollateral',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
    ],
    name: 'enableController',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'forgiveAccountStatusCheck',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  { inputs: [], name: 'forgiveVaultStatusCheck', outputs: [], stateMutability: 'payable', type: 'function' },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'getAccountOwner',
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'getAddressPrefix',
    outputs: [{ internalType: 'bytes19', name: '', type: 'bytes19' }],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'getCollaterals',
    outputs: [{ internalType: 'address[]', name: '', type: 'address[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'getControllers',
    outputs: [{ internalType: 'address[]', name: '', type: 'address[]' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'controllerToCheck', type: 'address' }],
    name: 'getCurrentOnBehalfOfAccount',
    outputs: [
      { internalType: 'address', name: 'onBehalfOfAccount', type: 'address' },
      { internalType: 'bool', name: 'controllerEnabled', type: 'bool' },
    ],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'getLastAccountStatusCheckTimestamp',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { internalType: 'uint256', name: 'nonceNamespace', type: 'uint256' },
    ],
    name: 'getNonce',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { internalType: 'address', name: 'operator', type: 'address' },
    ],
    name: 'getOperator',
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'getRawExecutionContext',
    outputs: [{ internalType: 'uint256', name: 'context', type: 'uint256' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'otherAccount', type: 'address' },
    ],
    name: 'haveCommonOwner',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'pure',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'operator', type: 'address' },
    ],
    name: 'isAccountOperatorAuthorized',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'isAccountStatusCheckDeferred',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
    ],
    name: 'isCollateralEnabled',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isControlCollateralInProgress',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'vault', type: 'address' },
    ],
    name: 'isControllerEnabled',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' }],
    name: 'isLockdownMode',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isOperatorAuthenticated',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' }],
    name: 'isPermitDisabledMode',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'isSimulationInProgress',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'vault', type: 'address' }],
    name: 'isVaultStatusCheckDeferred',
    outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [],
    name: 'name',
    outputs: [{ internalType: 'string', name: '', type: 'string' }],
    stateMutability: 'view',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'signer', type: 'address' },
      { internalType: 'address', name: 'sender', type: 'address' },
      { internalType: 'uint256', name: 'nonceNamespace', type: 'uint256' },
      { internalType: 'uint256', name: 'nonce', type: 'uint256' },
      { internalType: 'uint256', name: 'deadline', type: 'uint256' },
      { internalType: 'uint256', name: 'value', type: 'uint256' },
      { internalType: 'bytes', name: 'data', type: 'bytes' },
      { internalType: 'bytes', name: 'signature', type: 'bytes' },
    ],
    name: 'permit',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'uint8', name: 'index1', type: 'uint8' },
      { internalType: 'uint8', name: 'index2', type: 'uint8' },
    ],
    name: 'reorderCollaterals',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'requireAccountAndVaultStatusCheck',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [{ internalType: 'address', name: 'account', type: 'address' }],
    name: 'requireAccountStatusCheck',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  { inputs: [], name: 'requireVaultStatusCheck', outputs: [], stateMutability: 'payable', type: 'function' },
  {
    inputs: [
      { internalType: 'address', name: 'account', type: 'address' },
      { internalType: 'address', name: 'operator', type: 'address' },
      { internalType: 'bool', name: 'authorized', type: 'bool' },
    ],
    name: 'setAccountOperator',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { internalType: 'bool', name: 'enabled', type: 'bool' },
    ],
    name: 'setLockdownMode',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { internalType: 'uint256', name: 'nonceNamespace', type: 'uint256' },
      { internalType: 'uint256', name: 'nonce', type: 'uint256' },
    ],
    name: 'setNonce',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { internalType: 'address', name: 'operator', type: 'address' },
      { internalType: 'uint256', name: 'operatorBitField', type: 'uint256' },
    ],
    name: 'setOperator',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  {
    inputs: [
      { internalType: 'bytes19', name: 'addressPrefix', type: 'bytes19' },
      { internalType: 'bool', name: 'enabled', type: 'bool' },
    ],
    name: 'setPermitDisabledMode',
    outputs: [],
    stateMutability: 'payable',
    type: 'function',
  },
  { stateMutability: 'payable', type: 'receive' },
] as const
